<template>
  <div class="Aside">
    <!-- 左侧 -->
    <div class="aside_left">
      <div class="header">
        <img class="logoImg" src="../assets/image/home/lgo.png" alt="">
      </div>
      <div class="bottom">
        <ul class="bottom_ul">
          <li class="bottom_li" v-for="(item,index) in menuList" :key="item.id" v-auth="item.auth" :class="{ 'active': active == index}" @click="getClick(index, item)">
            <img class="navimg" :src="item.icon" alt="" />
            <span class="iconName">{{item.name}}</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- 右侧 -->
    <div class="aside_right" :style="{width: isShows ? '246px': '0'}">
      <div class="aside_right_top" v-if="isexhibit">
        <div class="header">大赛练习管理</div>
        <el-divider content-position="center">{{ childrenMenuData.name }}</el-divider>
      </div>
      <!-- {{ childrenMenuData.children }} -->
      <div class="aside_right_bottom" v-if="isexhibit">
        <div class="aside_ul" v-if="isexhibit">
          <div class="navitem" :class="{'active': actives == index}" v-for="(item,index) in childrenMenuChildren" :key="item.path">
            <div @click="getClicks(item,index)" :class="{ 'children-active': true, 'actives': actives == item.id}">
              <img class="navimg" :src="item.icon" alt=""> {{item.name}}
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { store, mutations } from '@/store/store.js'
import mins from './mins'
export default {
  name: 'Aside',
  computed: {
    isShows() {
      return store.isShow
    },
  },
  data() {
    return {
      isexhibit: true,
      timer: null
    }
  },
  mixins: [mins],
  created() {
    this.changeRouter()
  },
  methods: {
    changeStores: mutations.changeStore,
    getClick(idx) {
      if (this.active == idx) {
        return false
      }
      this.active = idx
      this.actives = 0

      this.$router.push(this.childrenMenuChildren[0].path)
    },
    getClicks(item, idx) {
      this.actives = idx
      this.$router.push(item.path)
    }
  },
  watch: {
    isShows(val) {
      if (val) {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.timer = setTimeout(() => { this.isexhibit = val }, 100)
        this.timer = null
      } else {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.isexhibit = val
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
};
</script>

<style lang="scss" scoped>
.Aside {
  display: flex;
  // width: 300px;
  height: 100%;
  .aside_left {
    width: 54px;
    height: 100%;
    background-color: #000;
    .header {
      height: 54px;
      width: 100%;
      font-weight: 700;
      // background-color: #fff;
    }

    .logoImg {
      display: inline-block;
      width: 100%;
      height: 100%;
      padding: 8px;
      box-sizing: border-box;
    }
    .bottom {
      height: calc(100% - 54px);
      background-color: #000;
      overflow: auto;
    }
    .bottom_ul {
      width: 100%;
      height: 100%;
      padding-bottom: 10px;
      box-sizing: border-box;
      overflow: auto;
      .bottom_li {
        padding: 4px;
        box-sizing: border-box;
        width: 100%;
        height: 54px;
        margin: 6px 0;
        cursor: pointer;
      }
      .bottom_li:nth-child(1) {
        margin-top: 0;
        margin-bottom: 6px;
      }
      // .bottom_li:hover {
      //     background-color: #4484f9;
      // }
      .active {
        background-color: #4484f9;
      }
      .navimg {
        display: block;
        height: 50%;
        margin: 0 auto;
      }
      .iconName {
        display: block;
        height: 50%;
        text-align: center;
        font-size: 14px;
        color: #fff;
      }
    }
  }
  .aside_right {
    transition: all 0.3s;
    position: relative;
    width: 0px;
    width: 246px;
    height: 100%;
    border-right: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    background-color: #fff;
    .planName {
      white-space: nowrap;
      display: block;
      position: absolute;
      top: 31px;
      left: 83px;
      height: 40px;
      // line-height: 40px;
      background-color: #fff;
      color: #000;
      font-size: 13x;
      font-weight: 500;
      padding: 20px;
      box-sizing: border-box;
    }
    .aside_right_top {
      // height: 60px;
      .header {
        white-space: nowrap;
        padding-top: 10px;
        box-sizing: border-box;
        text-align: center;
        font-size: 18px;
        color: #3b558b;
        background-color: #fff;
        height: 60px;
        line-height: 60px;
        // border-bottom: 1px solid #cccc;
      }
    }
    .aside_right_bottom {
      height: calc(100% - 110px);
      width: 100%;
      background-color: #fff;
    }
    .aside_ul {
      width: 100%;
      height: 100%;
      // padding-top: 20px;
      box-sizing: border-box;
      overflow: auto;
      padding-bottom: 10px;
      .navitem {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 50px;
        padding-right: 20px;
        box-sizing: border-box;
        cursor: pointer;
        a {
          text-decoration: none;
        }
      }
      .active {
        background-color: #4484f9;
      }

      // .navitem:hover {
      //     background-color: #4484f9;
      //     color: #fff;
      // }
      .navimg {
        display: inline-block;
        width: 40px;
        height: 40px;
        padding: 8px;
        box-sizing: border-box;
      }
      .children-active {
        // color: rgb(16, 16, 16) !important;
        display: flex;
        justify-content: space-around;
        align-items: center;
        white-space: nowrap;
      }
      // .children-active:hover {
      //     color: #fff !important;
      // }
      .actives {
        color: #fff !important;
      }
    }
    .asideCss3 {
      animation-name: fadenum;
      animation-duration: 3s;
    }
  }
}
</style>
